import { Component, OnInit, inject } from '@angular/core';
import {Router} from '@angular/router';
import {PlatformStorage} from '@app/core/tokens/platform-storage.token';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import { LoginInfoComponent } from '../../../shared/components/login-info/login-info.component';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    imports: [
        LoginInfoComponent,
        Bind,
        Button,
        TranslatePipe,
    ],
})
export class LogoutComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly storage = inject(PlatformStorage);
  private readonly router = inject(Router);


  ngOnInit(): void {
    this.oidcSecurityService.isAuthenticated().subscribe(isAuthenticated => {
      if (isAuthenticated) this.router.navigate(['/my-orders']);
    });
  }

  onLoginClicked() {
    this.oidcSecurityService.authorize();
  }
}
